import {
  getSurveyStatementKey,
  removeSurveyStatementKey,
  setSurveyBannerDismissed
} from 'utils/persistence'

import {SURVEY_MESSAGES, SurveyQuestion, SurveyStatementKey} from './constants'

const isSurveyStatementKey = (value: string): value is SurveyStatementKey =>
  value in SURVEY_MESSAGES

const getRandomStatementKey = (): SurveyStatementKey => {
  const keys = Object.keys(SURVEY_MESSAGES) as SurveyStatementKey[]

  return keys[Math.floor(Math.random() * keys.length)]
}

export const getQuestionByKey = (key: SurveyStatementKey): SurveyQuestion => ({
  questionId: key,
  statement: SURVEY_MESSAGES[key]
})

const restoreOrGetStatementKey = (): SurveyStatementKey => {
  const storedKey = getSurveyStatementKey()

  if (storedKey && isSurveyStatementKey(storedKey)) {
    return storedKey
  }

  return getRandomStatementKey()
}

export const restoreOrGetQuestion = (): SurveyQuestion =>
  getQuestionByKey(restoreOrGetStatementKey())

export const persistDismissal = () => {
  setSurveyBannerDismissed()
  removeSurveyStatementKey()
}
